import { useState } from "react";
import { inviteUserToGroup } from "../../services/firebase";
import { snackBarConfigType } from "../../classes/SnackBarConfig";
import User from "../../classes/User";
import CloseIcon from "../../assets/icons/cross-solid";

const InviteNewMemberToGroup: React.FC<{
  groupId: string;
  userId: string;
  createdGroupName: string;
  currentUser: User;
  setSnackBarConfig: (value: snackBarConfigType) => void;
  setShowInvitation: (value: boolean) => void;
}> = ({
  groupId,
  userId,
  createdGroupName,
  currentUser,
  setSnackBarConfig,
  setShowInvitation,
}) => {
  const [inviteCode, setInviteCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleInviteUser = async () => {
    if (!inviteCode.trim()) {
      setError("Enter a valid unique code to invite a user.");
      return;
    }
    if (!groupId) {
      setError("Create a group first before inviting users.");
      return;
    }

    setLoading(true);
    setError("");

    try {
      await inviteUserToGroup(
        groupId,
        userId,
        inviteCode,
        createdGroupName,
        currentUser.userName
      );
      setInviteCode("");

      setSnackBarConfig({
        open: true,
        severity: "success",
        message: "User invited successfully!",
      });
    } catch (error) {
      console.error("Error inviting user:", error);
      setError(error + "| Failed to send invite.");
    }

    setLoading(false);
  };

  return (
    <div className="bg-white rounded-3xl p-6 mt-4">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-grgrifter tracking-wider text-xl text-[#AFAEB3]">
          Invite New Member to Group
        </h3>
        <button
          onClick={() => setShowInvitation(false)}
          className="p-2 rounded-[0.9em] bg-[#CEE4CD]"
        >
          <CloseIcon color="#3A9437" size={20} />
        </button>
      </div>
      <div>
        <input
          type="text"
          placeholder="Enter user's email id ..."
          value={inviteCode}
          onChange={(e) => setInviteCode(e.target.value)}
          disabled={loading}
          className="w-full px-3 py-2 border focus:outline-none focus:ring focus:ring-[#3A9437] rounded-xl bg-[#efedf4] disabled:opacity-50"
        />
        {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
      </div>
      <button
        onClick={handleInviteUser}
        disabled={loading}
        className={`mt-3 w-full bg-[#3A9437] text-white py-2 rounded-2xl ${
          loading ? "opacity-50 cursor-not-allowed" : "hover:bg-[#3A9437]"
        }`}
      >
        {loading ? "Inviting..." : "Send Invite"}
      </button>
    </div>
  );
};

export default InviteNewMemberToGroup;
